import { Ride, useUnits } from '@geovelo-frontends/commons';
import { graphql } from 'gatsby';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { RideQuery } from '../../../../graphql-types';
import defaultRideImage from '../../../assets/images/ride.jpg';
import Seo from '../../../components/seo';
import useRedirect from '../../../hooks/redirect';
import { TPageProps } from '../../../page-props';
import { parseRide } from '../../../utils/ride';

function RideDetailsPage(props: TPageProps<RideQuery>) {
  const {
    data: { ride: _ride },
    params: { id },
    location: { search },
    pageContext,
  } = props;
  const [ride] = useState<Ride | undefined | null>(
    (_ride?.data && parseRide(_ride.data)) || undefined,
  );
  const { t } = useTranslation();
  const { toDistance, toTime } = useUnits();

  useRedirect({ slug: `/rides/${id || pageContext.id}`, search });

  const description =
    (ride &&
      `${toDistance(ride.distance || 0).replace(/\u00a0/g, ' ')} | ${toTime(
        ride.duration || 0,
      ).replace(/\u00a0/g, ' ')}${ride.description ? ` | ${ride.description}` : ''}`) ||
    '';

  return (
    <Seo
      isRoot
      description={description.length > 300 ? `${description.substring(0, 297)}...` : description}
      imageUrl={ride?.photos[0]?.thumbnailUrl || defaultRideImage}
      title={
        ride
          ? `${ride.title}${
              ride.from?.addressDetail?.city
                ? ` - ${t('geovelo.rides.detail.title_city', {
                    city: ride.from.addressDetail?.city,
                  })}`
                : ''
            } - ${t('geovelo.rides.detail.title')}`
          : t('geovelo.rides.detail.title')
      }
      {...props}
    />
  );
}

export const query = graphql`
  query Ride($id: Int, $withQuery: Boolean!) {
    ride(originalId: { eq: $id }) @include(if: $withQuery) {
      data {
        ...RideData
      }
    }
    allGeogroupWithRides {
      nodes {
        data {
          id
          partner {
            id
          }
        }
      }
    }
  }
`;

export default RideDetailsPage;
